<div class="deadline-row">
    <div class="avatar">
        <img alt="image" [alt]="this.text" [src]="this.image" />
    </div>
    <h4 class="text">{{this.text}}</h4>
</div>